import { render, staticRenderFns } from "./ProgramDetailsPage.vue?vue&type=template&id=d129e860&"
import script from "./ProgramDetailsPage.vue?vue&type=script&lang=js&"
export * from "./ProgramDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports